<template>
  <div class="default-layout">
    <!-- <div class="user">
      <img src="../../src/assets/images/1.jpg">
      <div class="user-name">轩辕书社<span>（当前客户）</span></div>
    </div> -->
    <!-- <nav> -->
    <!-- <el-tabs v-model="activeName" @tab-click="handleClick"> -->
    <!-- <el-tab-pane label="概览" name="overview" /> -->
    <!-- <el-tab-pane label="投放管理" name="launch"> -->
    <div class="path">
      <span :class="{'active':launchs === 1}" @click="launch(1)">朋友圈广告</span>
      <span :class="{'active':launchs === 2}" @click="launch(2)">公众号小程序广告</span>
      <span :class="{'active':launchs === 3}" @click="launch(3)">视频号互选</span>
    </div>
    <div>
      <launch-tab v-show="launchs === 1" />
      <advert-applets-public v-show="launchs === 2" />
      <account-select v-show="launchs === 3" />
    </div>
    <!-- </el-tab-pane> -->
    <!-- <el-tab-pane label="数据报告" name="dataReport">
          <div class="path">
            <span :class="{'active':datas === 1}" @click="material(1)">效果数据</span>
            <span :class="{'active':datas === 2}" @click="material(2)">用户分布</span>
            <span :class="{'active':datas === 3}" @click="material(3)">推广页分析</span>
          </div>
          <div>
            <effect-data v-show="datas === 1" />
            <user-distribution v-show="datas === 2" />
            <analyse v-show="datas === 3" />
          </div>
        </el-tab-pane> -->
    <!-- <el-tab-pane label="人群管理" name="crowd">
          <crowd />
        </el-tab-pane> -->
    <!-- <el-tab-pane label="素材中心" name="material">
          <div class="path">
            <span :class="{'active':add_class === 1}" @click="expand(1)">推广页管理</span>
            <span :class="{'active':add_class === 2}" @click="expand(2)">创建工具</span>
            <span :class="{'active':add_class === 3}" @click="expand(3)">素材库</span>
          </div>
          <div>
            <expand-page v-show="add_class === 1" />
            <creative-tools v-show="add_class === 2" />
          </div>
        </el-tab-pane> -->
    <!-- <el-tab-pane label="账户管理" name="account">
          <div class="path">
            <span :class="{'active':accounts === 1}" @click="account(1)">账户信息</span>
            <span :class="{'active':accounts === 2}" @click="account(2)">财务管理</span>
            <span :class="{'active':accounts === 3}" @click="account(3)">发票管理</span>
            <span :class="{'active':accounts === 4}" @click="account(4)">银行转账记录</span>
            <span :class="{'active':accounts === 5}" @click="account(5)">资质管理</span>
            <span :class="{'active':accounts === 6}" @click="account(6)">申请退款</span>
          </div>
          <div>
            <account v-show="accounts === 1" />
            <aptitudes v-show="accounts === 5" />
            <invoice v-show="accounts === 3" />
            <refund v-show="accounts === 6" />
            <transfer-record v-show="accounts === 4" />
          </div>
        </el-tab-pane> -->
    <!-- <el-tab-pane label="工具箱" name="toolboxes">
          <slot name="toolboxes" />
        </el-tab-pane>
        <el-tab-pane label="消息公告" name="newsBulletin">
          <slot name="newsBulletin" />
        </el-tab-pane> -->
    <!-- </el-tabs> -->
    <!-- </nav> -->
  </div>
</template>

<script>
// import ExpandPage from '@/views/materialCenter/expandPage'
// import CreativeTools from '@/views/materialCenter/creativeTools'
// import Crowd from '@/views/crowdManagement/crowd'
// import Account from '@/views/accountManagement/account'
// import Aptitudes from '@/views/accountManagement/aptitudes'
// import Invoice from '@/views/accountManagement/invoice'
// import Refund from '@/views/accountManagement/refund'
// import TransferRecord from '@/views/accountManagement/transferRecord'
import LaunchTab from '@/components/Advertising/launchManagement/LaunchTab'
import AdvertAppletsPublic from '@/components/Advertising/launchManagement/AdvertAppletsPublic.vue'
import AccountSelect from '@/components/Advertising/launchManagement/AccountSelect.vue'
// import EffectData from '@/views/dataReport/effectData'
// import UserDistribution from '../views/dataReport/userDistribution'
// import Analyse from '../views/dataReport/analyse'
export default {
  name: 'DefaultLayout',
  components: {
    // Analyse,
    // UserDistribution,
    // EffectData,
    LaunchTab,
    AdvertAppletsPublic,
    AccountSelect
    // TransferRecord,
    // Refund, Invoice,
    // Aptitudes,
    // Account,
    // Crowd,
    // CreativeTools,
    // ExpandPage
  },
  data() {
    return {
      // activeName: 'overview',
      // show: false,
      // add_class: 1,
      // accounts: 1,
      launchs: 1
      // datas: 1,
      // overviews: 1
    }
  },
  methods: {
    // 素材中心
    // expand(e) {
    //   this.add_class = e
    // },
    // 账户管理
    // account(e) {
    //   this.accounts = e
    // },
    // 数据报告
    // material(e) {
    //   this.datas = e
    // },
    // 投放管理
    launch(e) {
      this.launchs = e
    }
    // handleClick() {
    // }
  }
}

</script>

<style scoped lang="less">
  .active {
    color: #333333!important;
  }
  .path {
    height: 60px;
    span {
      color: silver;
      margin-right: 20px;
    }
    span:hover {
      color: #333333;
    }
  }
  .default-layout {
    padding: 20px 20px;
    // .user {
    //   padding: 10px 10px;
    //   display: flex;
    //   align-items: center;
      // img {
      //   width: 40px;
      //   height: 40px;
      // }
      // .user-name {
      //   flex-shrink: 0;
      //   margin-left: 10px;
      //   span {
      //     color: silver;
      //   }
      // }
    // }
    // nav {
    //   /deep/ .el-tabs__active-bar {
    //     background-color: rgb(14,194,101) !important;
    //   }
    //   /deep/ .el-tabs__item.is-active {
    //     color: rgb(14,194,101) !important;
    //   }
    //   /deep/ .el-tabs--top .el-tabs__item.is-top:nth-child(2) {
    //     padding-left: 10px;
    //   }
    //   /deep/ .el-tabs__item {
    //     font-size: 18px;
    //   }
    //   /deep/ .el-tabs__item:hover {
    //     color: rgb(14,194,101) !important;
    //   }
    // }
  }
</style>

